import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { css } from "styled-components";

addToCartButtonStyles.button = {
    css: css`
        border-radius: 10px;
        margin: 8px 0;
        background-color: #333;
        border: #333;
        min-height: 36px;
        width: 100%;
        :hover {
            background-color: #333;
        }
        :active {
            background-color: #333;
        }
    `,
};
